export var isOdd = x => Boolean(x % 2);
export var isEven = x => !isOdd(x);
